/**********************************************************************
 * PrerollsPlaylistExt.jsx — mostra il JSON atracks/vtracks
 *********************************************************************/
import React, { useEffect, useState } from 'react'
import api    from '../../services/api'
import Loader from '../Utils/Loader'
import '../../css/prerollsList.css'

export default function PrerollsPlaylistExt() {
  const [data , setData ] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/prerolls-ext/playlist')
        setData(data)
      } catch (err) {
        console.error(err)
        setError('Errore caricamento playlist')
      }
    })()
  }, [])

  if (error)  return <p style={{color:'red'}}>{error}</p>
  if (!data)  return <Loader />

  return (
    <div className="preroll-list">
      <h3>Audio tracks</h3>
      <pre style={{whiteSpace:'pre-wrap'}}>{JSON.stringify(data.atracks, null, 2)}</pre>

      <h3 style={{marginTop:24}}>Video tracks</h3>
      <pre style={{whiteSpace:'pre-wrap'}}>{JSON.stringify(data.vtracks, null, 2)}</pre>
    </div>
  )
}
